import { render, staticRenderFns } from "./Historialresultados.vue?vue&type=template&id=02ecccdc"
import script from "./Historialresultados.vue?vue&type=script&lang=js"
export * from "./Historialresultados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports